module.exports = __webpack_public_path__ + "static/media/training student.96a09e99.png";